import { render, staticRenderFns } from "./EventReview.vue?vue&type=template&id=1242465d&scoped=true"
import script from "./EventReview.vue?vue&type=script&lang=ts"
export * from "./EventReview.vue?vue&type=script&lang=ts"
import style0 from "./EventReview.vue?vue&type=style&index=0&id=1242465d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242465d",
  null
  
)

export default component.exports